import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, Injector, NgModule} from '@angular/core';

import {MainComponent} from './components/main/main.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {RequestInterceptor} from '../utils/services/RequestInterceptor';
import {AuthService} from '../utils/services/auth.service';
import {ChoseLocationComponent} from '../utils/components/chose-location/chose-location.component';
import {ChangeColumnsComponent} from '../utils/components/change-columns/change-columns.component';
import {WrapperComponent} from './components/wrapper/wrapper.component';
import {HeadActionsComponent} from './components/head-actions/head-actions.component';
import {ChangeCurrencyDialogComponent} from '../utils/components/change-currency-dialog/change-currency-dialog.component';
import {SortOrderDialogComponent} from '../utils/components/sort-order-dialog/sort-order-dialog.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ConfirmDialogComponent} from '../utils/components/confirm-dialog/confirm-dialog.component';
import {AppRouterModule} from './app-router.module';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {GlobalCommonModule} from './global-common.module';
import {MatDialogModule, MatExpansionModule, MatListModule} from '@angular/material';
import {SatPopoverModule} from '@ncstate/sat-popover';
import {PricesViewModule} from '../prices-view/prices-view.module';
import {TableColumnsService} from '../utils/services/table-columns.service';
import {exchangeProviderFactory, ExchangeService} from '../utils/services/exchange.service';
import {ServiceLocator} from '../utils/services/ServiceLocator';
import {HeaderService} from '../utils/services/header.service';
import {PriceChangesService} from '../prices-view/services/price-changes.service';
import { NgxChartsModule } from 'projects/ngx-charts/src/lib';
import {LoadFiltersDialogComponent} from '../utils/components/load-filters-dialog/load-filters-dialog.component';
import {SaveFiltersDialogComponent} from '../utils/components/save-filters-dialog/save-filters-dialog.component';
import { DynamicTablePaginatorService } from '../utils/components/dynamic-table-paginator/dynamic-table-paginator.service';

@NgModule({
  declarations: [
    MainComponent,
    ChoseLocationComponent,
    ChangeColumnsComponent,
    WrapperComponent,
    HeadActionsComponent,
    ChangeCurrencyDialogComponent,
    SortOrderDialogComponent,
    ConfirmDialogComponent,
    NotFoundComponent,
    LoadFiltersDialogComponent,
    SaveFiltersDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRouterModule,
    BrowserAnimationsModule,
    GlobalCommonModule,
    HttpClientModule,
    NgxChartsModule,
    DragDropModule,
    MatDialogModule,
    SatPopoverModule,
    PricesViewModule,
    MatExpansionModule,
    MatListModule,
  ],
  entryComponents: [
    ChoseLocationComponent,
    ChangeColumnsComponent,
    ChangeCurrencyDialogComponent,
    SortOrderDialogComponent,
    ConfirmDialogComponent,
    LoadFiltersDialogComponent,
    SaveFiltersDialogComponent
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true},
    AuthService,
    HeaderService,
    TableColumnsService,
    ExchangeService,
    PriceChangesService,
    DynamicTablePaginatorService,
    {
      provide: APP_INITIALIZER, useFactory: exchangeProviderFactory,
      deps: [ExchangeService], multi: true
    }
  ],
  exports: [],
  bootstrap: [MainComponent]
})
export class AppModule {
  constructor(private injector: Injector) {
    ServiceLocator.injector = injector;
  }
}
